import type { DragEndEvent } from "@dnd-kit/core";

type UserAction =
  | "USER_ADDS_UNIT"
  | "USER_REMOVES_UNIT"
  | "USER_MOVES_UNIT"
  | "USER_EXTENDS_UNIT_RIGHT"
  | "USER_EXTENDS_UNIT_LEFT"
  | "USER_CONTRACTS_UNIT_FROM_RIGHT"
  | "USER_CONTRACTS_UNIT_FROM_LEFT";

export const getUserDropAction = (event: DragEndEvent): UserAction | null => {
  const { active, over } = event;
  const activeTarget = active.data.current?.target;
  const activeData = active.data.current?.data;
  const overTarget = over?.data.current?.target;

  if (
    (activeTarget === "table-cell" && !over) ||
    (activeTarget === "table-cell" && overTarget === "drawer")
  ) {
    return "USER_REMOVES_UNIT";
  }

  if (activeTarget === "drawer-item" && overTarget === "empty-table-cell") {
    return "USER_ADDS_UNIT";
  }

  if (activeTarget === "table-cell" && overTarget === "empty-table-cell") {
    return "USER_MOVES_UNIT";
  }

  if (
    activeTarget === "span-control" &&
    overTarget === "empty-table-cell" &&
    activeData.direction === "right"
  ) {
    return "USER_EXTENDS_UNIT_RIGHT";
  }

  if (
    activeTarget === "span-control" &&
    overTarget === "empty-table-cell" &&
    activeData.direction === "left"
  ) {
    return "USER_EXTENDS_UNIT_LEFT";
  }

  if (
    activeTarget === "span-control" &&
    // inner-cell maintained for backwards compatability of old table for now
    (overTarget === "table-cell" || overTarget === "inner-cell") &&
    activeData.direction === "right" &&
    activeData.cellIndex === over?.data.current?.data.cellIndex
  ) {
    return "USER_CONTRACTS_UNIT_FROM_RIGHT";
  }

  if (
    activeTarget === "span-control" &&
    // inner-cell maintained for backwards compatability of old table for now
    (overTarget === "table-cell" || overTarget === "inner-cell") &&
    activeData.direction === "left" &&
    activeData.cellIndex === over?.data.current?.data.cellIndex
  ) {
    return "USER_CONTRACTS_UNIT_FROM_LEFT";
  }

  return null;
};
